import React, { useState } from "react";

const FeedbackForm = ({ submission, organizationName, affiliateMemberId, currentUser, onClose, onFeedbackAdded }) => {
  const [content, setContent] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const payload = {
      feedback: {
        user_id: currentUser,
        content,
      },
    };

    try {
      const res = await fetch(
        `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_submissions/${submission.id}/feedback.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        const newFeedback = await res.json();
        onFeedbackAdded(newFeedback);
        onClose();
      } else {
        const err = await res.json();
        console.error("Feedback submission failed", err);
      }
    } catch (err) {
      console.error("Error submitting feedback", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div id="feedback_form">
      <h6 className="mb-3">
        Please enter the feedback message you would like to send to the Member about this form submission
      </h6>

      <form onSubmit={handleSubmit}>
        <input type="hidden" name="feedback[user_id]" value={currentUser} />
        <label class="control-label text required" for="feedback_content"><abbr title="required">*</abbr> Content</label>

        <div className="form-group">
          <textarea
            name="feedback[content]"
            className="form-control"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            rows={4}
          />
        </div>

        <div className="d-flex justify-content-end mt-3">
          <button
            type="button"
            className="btn btn-secondary mr-2"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="btn btn-primary cursor-pointer"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Send Feedback..." : "Send Feedback"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FeedbackForm;
